import {L} from "./util.js";
import {PEER} from "./peer.js";
import {get_bandwidth} from "./main.js";
import {MEDIA} from "./mediautil.js";
import eachSeries from 'async-es/eachSeries';

export const RESOLUTION= {
 scaledown: async function(peer_id,value,cb) {
  let e = null;
  try {
   if(MEDIA.muteinfo.video) return;
   const pc = PEER.connections[peer_id];
   if(!pc) L.warn({peer_id,value},"unknown peer passed to scaledown");
   if(!pc.videosender) return;
   const pp = Object.assign({encodings:[{}]},pc.videosender.getParameters());
   if(!pp.encodings.length) pp.encodings.push({});
   value = Math.floor(value);
   if(pp.encodings[0].scaleResolutionDownBy==value) return;
   pp.encodings[0].scaleResolutionDownBy=Math.floor(value);
   await pc.videosender.setParameters(pp);
  }catch(ex) {
   e = ex;
   L.error({err:e,peer_id,value},"error while scaling down");
   if(!cb) throw ex;
  }finally { cb && cb(e) }
 }
};
export const FRAMERATE= {
 set: function(fr,cb) {
  if(MEDIA.muteinfo.video) return cb();
  eachSeries(Object.values(PEER.connections),(pc,cb)=>{
   if(!pc.videosender) return cb();
   const parameters = pc.videosender.getParameters();
   if(!parameters.encodings) {
    parameters.encodings = [];
   }
   if(!parameters.encodings.length) {
    parameters.encodings.push({});
   }
   if(parameters.encodings[0].maxFramerate==fr)//L.trace(`${pc.name} is already with the same framerate: ${fr}`);
    return cb();
   parameters.encodings[0].maxFramerate=fr;
   if(parameters.encodings[0].active)
    pc.videosender.setParameters(parameters)
    .then(()=>(/*L.trace({name: pc.name,framerate: fr},`Video framerate changed`),*/cb())).catch(ex=>{
     L.error({err:ex,peer:pc, framerate: fr},'Exception while applying video framerate');
     cb(ex);
    });
  },(e)=>{
   if(e) return L.error(e),cb(e);
   L.trace(`Applied framerate for all the available peers`);
   cb();
  });
 }
};
export const BANDWIDTH = {
 max_upload:1,
 max_download:2,
 set_bandwidth: function(pc,b,cb) {
  if(!pc) return L.error('No peer specified');
  b=+b;
  var ab=b/2;
  var vb=b/2;
  if(b<=1) vb=b*0.33334,ab=b*0.66667;
  if(ab<0.01) ab=0.01;
  var set_audio=()=>{
   if(pc.audiosender) {
    const aud_parameters = pc.audiosender.getParameters();
    if(!aud_parameters.encodings) {
     aud_parameters.encodings = [];
    }
    if(!aud_parameters.encodings.length) {
     aud_parameters.encodings.push({});
    }
   aud_parameters.encodings[0].maxBitrate=(ab*1000*1000);//Mbits
   aud_parameters.encodings[0].priority='high';
   aud_parameters.encodings[0].networkPriority='high';
    pc.audiosender.setParameters(aud_parameters)
    .then(()=>(/*L.trace({name: pc.name, bandwidth: ab},`Audio Bandwidth changed`),*/cb())).catch(ex=>{
     L.error({err:ex,peer:pc, bandwidth: ab},'Exception while applying audio bandwidth');
     cb(ex);
    });
   }
  };
  if(pc.videosender){
   const parameters = pc.videosender.getParameters();
   if(!parameters.encodings) {
    parameters.encodings = [];
   }
   if(!parameters.encodings.length) {
    parameters.encodings.push({});
   }
   parameters.encodings[0].maxBitrate=(vb*1000*1000);//Mbits
   parameters.encodings[0].priority='high';
   parameters.encodings[0].networkPriority='high';
    pc.videosender.setParameters(parameters)
    .then(()=>(L.trace({name: pc.name,bandwidth: vb},`Video Bandwidth changed`),set_audio())).catch(ex=>{
     L.error({err:ex,peer:pc, bandwidth: vb},'Exception while applying video bandwidth');
     cb(ex);
    });
  }
 },
 update_peers_bandwidth: function(cb) {
  var pl=Object.keys(PEER.connections).length;
  if(pl>=3) pl=3;
  const mul=+get_bandwidth().ul;
  eachSeries(Object.values(PEER.connections),(pc,cb)=>{
   let dl=(mul<=pc.mdl)?mul:pc.mdl;
   L.trace('setting bandwidth',{yourupload:mul,peerdownload:pc.mdl, qualified:dl});
   dl=(dl/pl);
   BANDWIDTH.set_bandwidth(pc,dl,(ex)=>{
    if(ex) L.error(ex);
    cb();
   });
  },(e)=>{
   if(e) return L.error(e),cb(e);
   L.trace(`Applied bandwith for all the available peers`);
   cb();
  });
 }
};
